import type { OrganizationUnit } from '../dtos'
import { OrganizationUnitType } from '../enums'

export const IsSupervisor = (organization: OrganizationUnit) => {
    return organization.type === OrganizationUnitType.Supervizor || organization.type === OrganizationUnitType.CebiaSupervizor
}